//#region Auth
export const LOGIN = 'LOGIN';
export const GET_PROFILE = 'GET_PROFILE';
export const LOGIN_WITH_URL = 'LOGIN_WITH_URL';
export const CREATE_CANVAS_TOKEN = 'CREATE_CANVAS_TOKEN';
export const GET_STUDENT = 'GET_STUDENT';
export const UPDATE_USERS = 'UPDATE_USERS';
//#endregion Auth

//#region Notifications
export const GET_LIST_NOTIFICATIONS = 'GET_LIST_NOTIFICATIONS';
//#endregion Notifications

//#region Course
export const UPDATE_COURSES = 'UPDATE_COURSES';
export const GET_LIST_COURSES = 'GET_LIST_COURSES';
export const GET_LIST_UPCOMING_COURSES = 'GET_LIST_UPCOMING_COURSES';
export const GET_DETAIL_COURSES = 'GET_DETAIL_COURSES';
export const GET_COURSES_OF_STUDENT = 'GET_COURSES_OF_STUDENT';
export const GET_MODULE_OF_COURSE = 'GET_MODULE_OF_COURSE';
export const GET_COURSES_DETAIL_OF_STUDENT = 'GET_COURSES_DETAIL_OF_STUDENT';
export const GET_DISCUSSION_OF_COURSE = 'GET_DISCUSSION_OF_COURSE';

//#endregion Course

//#region User
export const UPDATE_PROFILE = 'UPDATE_PROFILE';
//#endregion User

//#region Tuition
export const GET_LIST_TUITION = 'GET_LIST_TUITION';
export const CREATE_TUITION = 'CREATE_TUITION';
export const UPDATE_TUITION = 'UPDATE_TUITION';
export const GET_TUITION_BY_ID = 'GET_TUITION_BY_ID';
export const DELETE_TUITION_BY_ID = 'DELETE_TUITION_BY_ID';
//#endregion Tuition

//#region Exam
export const GET_LIST_EXAM = 'GET_LIST_EXAM';
export const CREATE_EXAM = 'CREATE_EXAM';
export const UPDATE_EXAM = 'UPDATE_EXAM';
export const DELETE_EXAM_BY_ID = 'DELETE_EXAM_BY_ID';
export const GET_EXAM_BY_ID = 'GET_EXAM_BY_ID';
//#endregion Exam

//#region Discussion Forum Grading
export const GET_LIST_DISCUSSION_FORUM_GRADING = 'GET_LIST_DISCUSSION_FORUM_GRADING';
export const CREATE_DISCUSSION_FORUM_GRADING = 'CREATE_DISCUSSION_FORUM_GRADING';
export const UPDATE_DISCUSSION_FORUM_GRADING = 'UPDATE_DISCUSSION_FORUM_GRADING';
export const DELETE_DISCUSSION_FORUM_GRADING = 'DELETE_DISCUSSION_FORUM_GRADING';
//#endregion Discussion Forum Grading

//#region Discussion
export const GET_DETAIL_DISCUSSION = 'GET_DETAIL_DISCUSSION';
export const GET_DISCUSSION_ENTRIES = 'GET_DISCUSSION_ENTRIES';
export const GET_FULL_DISCUSSION_ENTRIES = 'GET_FULL_DISCUSSION_ENTRIES';
export const CREATE_ENTRY = 'CREATE_ENTRY';
export const UPDATE_ENTRY = 'UPDATE_ENTRY';
export const CREATE_REPLY = 'CREATE_REPLY';
export const DELETE_ENTRY = 'DELETE_ENTRY';
export const MARK_READ_ALL_ENTRIES = 'MARK_READ_ALL_ENTRIES';
//#endregion Discussion

//#region Quiz
export const GET_DETAIL_QUIZ = 'GET_DETAIL_QUIZ';
export const START_QUIZ = 'START_QUIZ';
export const ANSWER_QUESTION = 'ANSWER_QUESTION';
export const ANSWER_FILE_QUESTION = 'ANSWER_FILE_QUESTION';
export const COMPLETE_QUIZ = 'COMPLETE_QUIZ';
//#endregion Quiz

//#region Module
export const GET_LIST_MODULE = 'GET_LIST_MODULE';
export const UPSERT_MODULE_WATCH_PROGRESS = 'UPSERT_MODULE_WATCH_PROGRESS';
//#endregion Module